const routes = [
    {
        path: "/course/code/request/form",
        component: () => import("../pages/RequestForm"),
        meta: {
            isAuthenticated: true,
        },
    },
];

export default routes;
